import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { MouseEventHandler } from 'react';

import { FilterTag } from '@revelio/ui';

import styles from './primary-filter-chip.module.css';

export const PrimaryFilterTag = ({
  label,
  id,
  onRemoveChip,
  color,
  isRemoveDisabled = false,
}: {
  label: string;
  id: string;
  onRemoveChip: MouseEventHandler<HTMLSpanElement>;
  color?: string;
  isRemoveDisabled?: boolean;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };

  return (
    <FilterTag
      ref={setNodeRef}
      style={style}
      className={styles.themedChip}
      color={color}
      data-testid="primary-filter-chip"
      data-active
      onRemove={onRemoveChip}
      removeDisabled={isRemoveDisabled}
      removeTestId="primary-filter-chip-remove"
      {...listeners}
      {...attributes}
    >
      {label}
    </FilterTag>
  );
};
